import React from 'react';

const Footer = () => {
    return (
        <footer className="p-5 footer">
            <p>All Rights Reserved © Techno <span className="text-danger">Learning</span></p>
        </footer>
    );
};

export default Footer;